import classNames from "classnames";
import React from "react";
import { Icon, Icomoon } from "../..";

import "./CircleIcon.scss";

interface Props {
  icon: string;
  className?: string;
}

/**
 * An icon with a circular background.
 * 
 * @status review
 * - reusability (component is invisible unless .circle-icon-inner has a background)
 * - style (does not use BEM)
 * - usefulness (only used in two places)
 */
export const CircleIcon = ({ icon, className }: Props) => (
  <div className={classNames("circle-icon", className)}>
    <div className={classNames("circle-icon-inner")}>
      <Icon icomoon={icon as Icomoon} />
    </div>
  </div>
);
